import { Link } from 'react-router-dom';
import { Mic, Milk, Wheat, Droplets, CookingPot, Carrot, Egg, Coffee, Cross, Baby, Sparkles, Cookie, Flame } from 'lucide-react';
import { openVoiceOrder } from './BottomNav';
import LiveClock from './LiveClock';

const ESSENTIALS = [
  { key: 'milk', label: 'Milk', hi: 'दूध', q: 'milk', Icon: Milk, bg: '#E3F2FD', fg: '#0D47A1' },
  { key: 'atta', label: 'Atta & Rice', hi: 'आटा चावल', q: 'atta rice', Icon: Wheat, bg: '#FFF8E1', fg: '#8D6E00' },
  { key: 'oil', label: 'Oil', hi: 'तेल', q: 'oil', Icon: Droplets, bg: '#FFF3E0', fg: '#8D3A0A' },
  { key: 'dal', label: 'Dal', hi: 'दाल', q: 'dal', Icon: CookingPot, bg: '#EFEBE9', fg: '#5D4037' },
  { key: 'veg', label: 'Sabzi', hi: 'सब्ज़ी', q: 'vegetable', Icon: Carrot, bg: '#E8F5E9', fg: '#1B5E20' },
  { key: 'eggs', label: 'Eggs & Bread', hi: 'अंडे ब्रेड', q: 'egg bread', Icon: Egg, bg: '#FFF8E1', fg: '#8D6E00' },
  { key: 'tea', label: 'Tea & Sugar', hi: 'चाय चीनी', q: 'tea sugar', Icon: Coffee, bg: '#EFEBE9', fg: '#4E342E' },
  { key: 'snacks', label: 'Biscuits', hi: 'बिस्किट', q: 'biscuit', Icon: Cookie, bg: '#FBE9E7', fg: '#8D3A0A' },
  { key: 'soap', label: 'Soap & Surf', hi: 'साबुन', q: 'soap detergent', Icon: Sparkles, bg: '#E0F7FA', fg: '#006064' },
  { key: 'gas', label: 'Matchbox', hi: 'माचिस', q: 'matchbox', Icon: Flame, bg: '#FFEBEE', fg: '#B71C1C' },
  { key: 'medicine', label: 'Medicine', hi: 'दवाई', q: 'paracetamol', Icon: Cross, bg: '#FFEBEE', fg: '#B71C1C' },
  { key: 'baby', label: 'Baby Care', hi: 'बच्चों का', q: 'baby', Icon: Baby, bg: '#F3E5F5', fg: '#4A148C' },
];

export function VoiceOrderHero() {
  return (
    <section className="max-w-3xl mx-auto px-4 md:px-6 pt-4" data-testid="home-voice-hero">
      <button data-testid="home-voice-order-hero-btn" onClick={openVoiceOrder}
        className="w-full rounded-2xl bg-[#1B5E20] hover:bg-[#0D3F12] text-white p-4 flex items-center gap-4 text-left active:scale-[0.99] transition-transform">
        <span className="w-16 h-16 rounded-full bg-white text-[#1B5E20] grid place-items-center shrink-0 ring-4 ring-white/30">
          <Mic className="w-8 h-8"/>
        </span>
        <span className="flex-1 min-w-0">
          <span className="block text-[10px] uppercase tracking-[0.2em] font-black text-white/70">No typing needed</span>
          <span className="block font-heading font-black text-2xl leading-tight">Bolo, order ho jayega</span>
          <span className="block text-xs text-white/80 mt-0.5">Speak your list — AI fills your cart from the nearest shop.</span>
        </span>
      </button>
    </section>
  );
}

export default function EssentialsGrid() {
  return (
    <section className="max-w-3xl mx-auto px-4 md:px-6 py-4" data-testid="home-essentials-grid">
      <div className="flex items-end justify-between gap-2 mb-2">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] font-black text-ink/60">Roz ka saamaan</div>
          <div className="font-heading font-black text-xl">Daily Essentials</div>
        </div>
        <LiveClock testid="home-live-clock" className="text-[11px] font-bold text-ink/60"/>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2.5">
        {ESSENTIALS.map(({ key, label, hi, q, Icon, bg, fg }) => (
          <Link key={key} to={`/search?q=${encodeURIComponent(q)}`} data-testid={`essential-tile-${key}`}
            className="rounded-2xl border-2 border-transparent hover:border-ink/30 active:scale-95 transition-transform p-3 flex flex-col items-center justify-center text-center min-h-[96px]"
            style={{ backgroundColor: bg }}>
            <Icon className="w-8 h-8" style={{ color: fg }}/>
            <span className="mt-1.5 text-xs font-black uppercase tracking-wide leading-tight" style={{ color: fg }}>{label}</span>
            <span className="text-[11px] font-semibold opacity-70" style={{ color: fg }}>{hi}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
